const initialState = {
    statusShow: false,
    order:null,
    rate:5,
    comment:'',
    loader:false
};
const modalSurvey = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_SURVEY':
            return action.statusShow ? {...state, statusShow: action.statusShow,order:action.order}: {...initialState};
        case 'CHANGE_INPUTS_MODAL_SURVEY':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalSurvey;